import { Button } from "../components/Button";
import { VideoCapturePanel } from "../components/VideoCapturePanel";
import { VerifyStepList } from "../components/VerifyStepList";
import { useFlow } from "../flow/FlowContext";
import { VIDEO_MAX_SECONDS } from "../media/limits";
import { useT } from "../i18n";

export function VerifyVideoScreen() {
  const { answers, setConfirmationVideo, next, canContinue, userId } = useFlow();
  const t = useT();

  return (
    <>
      <div
        className="screen-enter"
        style={{ flex: 1, display: "flex", flexDirection: "column", gap: 18 }}
      >
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("verify.video.eyebrow")}</div>
          <h1 className="screen-head__title">{t("verify.video.title")}</h1>
          <p className="screen-head__text">
            {t("verify.video.text", { seconds: VIDEO_MAX_SECONDS })}
          </p>
        </header>
        <VerifyStepList
          statuses={{
            id: "done",
            video: "active",
            photos: "pending",
            review: "pending",
          }}
        />
        <VideoCapturePanel
          asset={answers.confirmationVideo}
          userId={userId ?? ""}
          onChange={setConfirmationVideo}
        />
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.continue")}
        </Button>
      </div>
    </>
  );
}
